import Btn from './components/Btn'
import Modal from './components/Modal'
import axios from 'axios';

new Vue({
    el: '#app',
    components: {Btn, Modal},
    data() {
        return {
            email: null,
            saving: false,
            modalShow: false,
            modalMessage: null,
            success: false,
        }
    },
    methods: {
        save() {
            if (!this.email) {
                return;
            }

            if (!this.email.length) {
                return;
            }

            this.success = false;
            this.saving = true;
            axios.post('/learning', {
                email: this.email,
            }).then((response) => {
                console.log('data', response.data);
                if (response.data.hasOwnProperty('message')) {
                    this.modalMessage = response.data.message;
                }

                this.success = true;
                this.modalShow = true;
                this.email = '';
            })
            .catch((error) => {
                console.log('error', error);
                const response = error.response;
                console.log('data', response.data);
                if (response.data.hasOwnProperty('errors')) {
                    if (response.data.errors.hasOwnProperty('email')) {
                        this.modalMessage = response.data.errors.email[0];
                    }
                }
                this.modalShow = true;
            })
            .finally(() => {
                this.saving = false;
            });
        }
    }
})